import { render, staticRenderFns } from "./CmdButton.vue?vue&type=template&id=1254a68f&scoped=true"
import script from "./CmdButton.vue?vue&type=script&lang=js"
export * from "./CmdButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1254a68f",
  null
  
)

export default component.exports